<template>
    <IndexModelLayout
        :createRoute="$route('admin::reminders.create')"
        :modelNamePlural="__('admin::reminders.reminders')"
    >

        <Table
            :headings="[
                __('admin::labels.name'),
                __('admin::labels.frequency'),
            ]"
            :paginator="paginator"
            @filter="submit"
        >

            <template #filters>
                <Input :placeholder="__('admin::forms.search')" v-model="filter.search" variant="filter" />
            </template>

            <template #results>
                <tr v-for="reminder in paginator.data" :key="reminder.id">
                    <td>{{ reminder.name }}</td>
                    <td>{{ reminder.frequency }}</td>
                    <td>
                        <TableButton
                            variant="edit"
                            :href="$route('admin::reminders.edit', { reminder: reminder.id })"
                        />
                        <TableButton
                            variant="destroy"
                            @delete="deleting = $route('admin::reminders.destroy', { reminder: reminder.id })"
                        />
                    </td>
                </tr>
            </template>

        </Table>

        <DeleteDialog
            :title="__('admin::general.delete_model', { model: __('admin::reminders.reminder') })"
            :url="deleting"
            v-if="deleting"
            @closed="deleting = null"
        />

    </IndexModelLayout>
</template>

<script>
    export default {
        props: {
            paginator: Object,
            request: Object,
        },
        data() {
            return {
                filter: this.$inertia.form({
                    search: this.request.search,
                }),
                deleting: null,
            }
        },
        methods: {
            submit() {
                this.filter.get(this.$route('admin::reminders.index'));
            },
        },
    }
</script>
